export default __webpack_public_path__ + "static/screen_earn-db264987277963052dff6ef4775b5d4f.png";